import { SvgIconProps } from '@euler/app/components/icons/types';
import { useSvgProps } from '@euler/app/components/icons/util';
import { FC, memo } from 'react';
import { Path, Svg } from 'react-native-svg';

export const RecordsTabIconFill: FC<SvgIconProps> = memo(props => {
  const { fill = '#000', ...svgProps } = useSvgProps(props, 21, 21);
  return (
    <Svg viewBox="0 0 1024 1024" fill="none" {...svgProps}>
      <Path
        d="M813.248 778.88V711.04a33.92 33.92 0 0 0-67.776 0v101.568c0 18.752 15.168 33.92 33.92 33.92h101.568a33.92 33.92 0 1 0 0-67.776h-67.712zM586.88 1015.104H68.224a67.712 67.712 0 0 1-67.712-67.712V67.712C0.512 30.336 30.848 0 68.224 0h812.032c37.44 0 67.776 30.336 67.776 67.712v457.28a304.768 304.768 0 0 0-361.088 490.24zM203.52 236.864a33.92 33.92 0 1 0 0 67.648h406.08a33.92 33.92 0 1 0 0-67.648H203.52z m0 203.008a33.92 33.92 0 1 0 0 67.712h270.72a33.92 33.92 0 1 0 0-67.712H203.52z m575.808 576a237.056 237.056 0 1 1 0-474.048 237.056 237.056 0 0 1 0 474.048z"
        fill={fill}
      />
    </Svg>
  );
});

export const RecordsTabIcon: FC<SvgIconProps> = memo(props => {
  const { fill = '#000', ...svgProps } = useSvgProps(props, 21, 21);
  return (
    <Svg viewBox="0 0 1024 1024" fill="none" {...svgProps}>
      <Path
        d="M832 160v256h-64v-256H128v704h401.472v64H128a64 64 0 0 1-64-64v-704a64 64 0 0 1 64-64h640a64 64 0 0 1 64 64z m-640 320h320v64H192v-64z m0-192h512v64H192v-64z m0 384h192v64H192v-64z m608 32h64v64h-128V608h64V704z m-32 256a224 224 0 1 1 0-448 224 224 0 0 1 0 448z m0-64a160 160 0 1 0 0-320 160 160 0 0 0 0 320z"
        fill={fill}
      />
    </Svg>
  );
});
